export default () => {
  document.addEventListener('click', (e) => {
    if (!e.target.matches('.hamburger')) return;

    e.target.classList[e.target.matches('.is-active') ? 'remove' : 'add']('is-active');

    document.body.classList[document.body.matches('.menu-is-open') ? 'remove' : 'add']('menu-is-open');
  });
};
